import { DelayLink } from './DelayLink';

export default DelayLink;
